(() => {
  function initAccordions() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ps-accordion-trigger]');
      if (!button) return;

      const panel = button.closest('.ps-accordion')?.querySelector('[data-ps-accordion-panel]');
      if (!panel) return;

      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.classList.toggle('is-open', !expanded);
      panel.hidden = expanded;
    });
  }

  initAccordions();

  const dataEl = document.getElementById('ps-gallery-data');
  const gallery = dataEl ? JSON.parse(dataEl.textContent) : [];
  const image = document.getElementById('gallery-image');
  const dots = document.getElementById('gallery-dots');
  const count = document.getElementById('gallery-count');
  let active = 0;

  // Outline blob behind the photo: only once the photo has loaded, and only on the first 2 images
  const stage = image?.closest('.ps-gallery__stage');
  const pdpRoot = image?.closest('.ps-product');
  function updateLine() {
    pdpRoot?.setAttribute('data-gallery-slide', String(active)); // mobile blob position follows the slide
    if (!stage || !image) return;
    stage.classList.toggle('is-line-visible', active < 2 && image.complete && image.naturalWidth > 0);
  }
  image?.addEventListener('load', updateLine);

  function setGalleryImage(item) {
    if (!image || !item?.src) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    stage?.classList.remove('is-line-visible');
    image.src = item.src;
    image.alt = item.alt || '';
    updateLine();
  }

  if (gallery.length && image && dots) {
    gallery.forEach((item, index) => {
      const button = document.createElement('button');
      button.className = 'ps-gallery__dot';
      button.type = 'button';
      button.setAttribute('aria-label', `Show product image ${index + 1}`);
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      if (index === 0) button.classList.add('is-active');
      button.addEventListener('click', () => show(index));
      dots.appendChild(button);
    });

    // Preload + decode every gallery image once the page has loaded, so switching is instant
    const cache = gallery.map(() => null);
    const preload = (i) => {
      if (!cache[i] && gallery[i]?.src) {
        const img = new Image();
        img.decoding = 'async';
        img.src = gallery[i].src;
        cache[i] = img.decode ? img.decode().then(() => img).catch(() => img) : Promise.resolve(img);
      }
      return cache[i] || Promise.resolve(null);
    };
    const preloadAll = () => gallery.forEach((_, i) => preload(i));
    if (document.readyState === 'complete') preloadAll();
    else window.addEventListener('load', preloadAll, { once: true });

    // Cross-fade: the next image fades in over the current one, then replaces it
    let token = 0;
    function show(index) {
      const next = (index + gallery.length) % gallery.length;
      if (next === active) return;
      const my = ++token;
      active = next;
      if (count) count.textContent = `${active + 1} / ${gallery.length}`;
      [...dots.children].forEach((dot, i) => {
        const isActive = i === active;
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        dot.classList.toggle('is-active', isActive);
      });
      stage?.classList.toggle('is-line-visible', active < 2);
      preload(next).then(() => {
        if (my !== token) return;
        stage?.querySelectorAll('.ps-gallery__image--incoming').forEach((el) => el.remove());
        const incoming = document.createElement('img');
        incoming.className = 'ps-gallery__image ps-gallery__image--incoming';
        incoming.src = gallery[next].src;
        incoming.alt = '';
        incoming.setAttribute('aria-hidden', 'true');
        stage.appendChild(incoming);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          incoming.classList.add('is-in');
          image.classList.add('is-leaving');
        }));
        window.setTimeout(() => {
          if (my !== token) { incoming.remove(); return; }
          // Swap the real image underneath with no transition, and only drop the overlay once it has painted
          image.style.transition = 'none';
          setGalleryImage(gallery[next]);
          const ready = image.decode ? image.decode().catch(() => {}) : Promise.resolve();
          ready.then(() => {
            if (my !== token) return;
            image.classList.remove('is-leaving');
            requestAnimationFrame(() => requestAnimationFrame(() => {
              incoming.remove();
              image.style.transition = '';
            }));
          });
        }, 320);
      });
    }

    document.getElementById('gallery-prev')?.addEventListener('click', () => show(active - 1));
    document.getElementById('gallery-next')?.addEventListener('click', () => show(active + 1));

    // The first image is already rendered (responsive srcset) — don't swap it, that caused a reload flicker
  }
  updateLine();

  const variantsEl = document.getElementById('ps-variants-data');
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const variantInput = document.getElementById('ps-variant-id');
  const priceEl = document.getElementById('ps-product-price');
  const taxNote = priceEl?.querySelector('small')?.textContent?.trim() || 'Tax included';

  function formatMoney(cents) {
    const amount = Number(cents) / 100;
    return `₹${amount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  }

  function getSelectedOptions() {
    const groups = [...document.querySelectorAll('[data-ps-option-group]')].sort(
      (a, b) => Number(a.dataset.psOptionGroup) - Number(b.dataset.psOptionGroup)
    );
    return groups.map((group) => group.querySelector('input[type="radio"]:checked')?.value).filter(Boolean);
  }

  function findVariant(selected) {
    return variants.find((variant) => selected.every((value, index) => variant[`option${index + 1}`] === value));
  }

  function updateVariant() {
    const groups = document.querySelectorAll('[data-ps-option-group]');
    if (!groups.length || !variantInput) return;

    if (groups.length === 1) {
      const checked = groups[0].querySelector('input[type="radio"]:checked');
      if (!checked) return;
      if (checked.dataset.variantId) {
        variantInput.value = checked.dataset.variantId;
        if (priceEl && checked.dataset.variantPrice) {
          priceEl.innerHTML = `${checked.dataset.variantPrice} <small>${taxNote}</small>`;
        }
        return;
      }
    }

    const selected = getSelectedOptions();
    const variant = findVariant(selected);
    if (!variant) return;
    variantInput.value = variant.id;
    if (priceEl) {
      priceEl.innerHTML = `${formatMoney(variant.price)} <small>${taxNote}</small>`;
    }
  }

  document.querySelectorAll('[data-ps-option-group] input[type="radio"]').forEach((input) => {
    input.addEventListener('change', updateVariant);
  });

  const qty = document.getElementById('qty');
  document.getElementById('qty-minus')?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, Number(qty.value || 1) - 1); });
  document.getElementById('qty-plus')?.addEventListener('click', () => { if (qty) qty.value = Math.min(12, Number(qty.value || 1) + 1); });

  /* Pincode delivery checker: asks the store's Cirkle "shipping rates by pincode" app (same service the
     previous theme used) whether there is a shipping rate for this product to that pincode. */
  document.querySelectorAll('[data-ps-delivery-form]').forEach((form) => {
    const input = form.querySelector('input[inputmode="numeric"]');
    const button = form.querySelector('button[type="submit"]');
    const messageId = form.id.replace('delivery-form', 'delivery-message');
    const message = document.getElementById(messageId) || form.parentElement?.querySelector('.ps-delivery__message');
    const say = (text, ok) => { if (message) { message.style.color = ok === null ? '' : ok ? '#27663a' : '#a13927'; message.textContent = text; } };
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const postcode = (input?.value || '').trim();
      if (!/^\d{6}$/.test(postcode)) { say('Please enter a valid 6-digit pincode.', false); return; }
      const d = form.dataset;
      const variantId = document.getElementById('ps-variant-id')?.value || d.variantId; // follows the selected size/pack
      const body = new URLSearchParams({
        'rate[destination][postal_code]': postcode, 'rate[destination][province]': '', 'rate[destination][country]': '',
        'rate[items][0][quantity]': '1', 'rate[items][0][grams]': d.grams || '0', 'rate[items][0][price]': d.price || '0',
        'rate[items][0][vendor]': d.vendor || '', 'rate[items][0][product_id]': d.productId || '', 'rate[items][0][variant_id]': variantId || '',
        'rate[items][0][sku]': d.sku || '', 'rate[items][0][type]': d.type || '', 'rate[items][0][tag]': d.tag || '', 'rate[items][0][name]': d.name || '',
        shop: d.shop || '',
      });
      say('Checking…', null);
      if (button) button.disabled = true;
      try {
        const res = await fetch('https://sbz.cirkleinc.com/front-widget', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' }, body });
        const data = await res.json();
        if (Array.isArray(data.rates) && data.rates.length) say('Yes, we deliver to this location!', true);
        else say("Sorry! Shipping isn't available for this location.", false);
      } catch (err) {
        say("Couldn't check delivery right now — please try again in a moment.", false);
      } finally { if (button) button.disabled = false; }
    });
  });

  const rivals = [...document.querySelectorAll('.ps-compare__col--rival')];
  if (rivals.length) {
    let rivalIndex = 0;
    const showRival = () => rivals.forEach((col, i) => col.classList.toggle('is-active', i === rivalIndex));
    document.querySelectorAll('.ps-compare__next').forEach((button) => {
      button.addEventListener('click', () => {
        rivalIndex = (rivalIndex + 1) % rivals.length;
        showRival();
      });
    });
    showRival();
  }

})();
